<button type="submit" [disabled]="disabled" [class]="getClasses()" [attr.aria-live]="ariaLive"	><i class="twingle-{{icon}}"></i>{{ text }}</button>
<p *ngIf="secureText" class="hint">
	<i class="twingle-lock_black"></i>
	{{ secureText }}
</p>
